import {Font, fontStyles} from 'lib/FontSelect'
import styled from 'styled-components'

const Description = styled.p<{
  color: string | null
  font: Font | null
}>`
  color: ${(props) => props.color};
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0.16px;
  margin-bottom: ${(props) => props.theme.spacing[6]};
  ${(props) => fontStyles(props.font)}
`

export default Description
